import { Component, OnInit, inject } from "@angular/core";
import {
  FormBuilder,
  FormGroup,
  Validators,
  FormsModule,
  ReactiveFormsModule
} from "@angular/forms";
import {
  MAT_DIALOG_DATA,
  MatDialogRef,
  MatDialogContent,
  MatDialogActions
} from "@angular/material/dialog";
import { ResourceZone } from "@app/models/rest/resource-zone";
import { ResourceModel } from "@app/models/rest/resource";
import { Zone } from "@app/models/rest/zone";
import { ResourceFactMappingPattern } from "@app/models/rest/resource-fact-mapping-pattern";
import { CdkScrollable } from "@angular/cdk/scrolling";
import {
  MatFormField,
  MatLabel,
  MatError,
  MatSuffix
} from "@angular/material/form-field";
import { MatSelect } from "@angular/material/select";
import { MatOption } from "@angular/material/core";
import { MatInput } from "@angular/material/input";
import {
  MatDatepickerInput,
  MatDatepickerToggle,
  MatDatepicker
} from "@angular/material/datepicker";
import { MatButton } from "@angular/material/button";
import { DialogHeaderComponent } from "@app/view/shared/dialog-header/dialog-header.component";
import moment from "moment/moment";

interface ZoneSelectionDialogData {
  resource: ResourceModel;
  zones: Zone[];
  mappingPatterns: ResourceFactMappingPattern[];
}

@Component({
  selector: "app-zone-selection-dialog",
  templateUrl: "./zone-selection-dialog.component.html",
  styleUrls: ["./zone-selection-dialog.component.scss"],
  imports: [
    DialogHeaderComponent,
    CdkScrollable,
    MatDialogContent,
    FormsModule,
    ReactiveFormsModule,
    MatFormField,
    MatLabel,
    MatSelect,
    MatOption,
    MatError,
    MatInput,
    MatDatepickerInput,
    MatDatepickerToggle,
    MatSuffix,
    MatDatepicker,
    MatDialogActions,
    MatButton
  ]
})
export class ZoneSelectionDialogComponent implements OnInit {
  private fb = inject(FormBuilder);
  private dialogRef =
    inject<MatDialogRef<ZoneSelectionDialogComponent>>(MatDialogRef);
  data = inject<ZoneSelectionDialogData>(MAT_DIALOG_DATA);

  zoneForm: FormGroup;

  ngOnInit(): void {
    // Set up the form
    this.zoneForm = this.fb.group({
      zone: [null, Validators.required],
      startDate: [null],
      endDate: [null],
      mappingPattern: [null]
    });
  }

  saveZone(): void {
    if (!this.zoneForm.valid) {
      return;
    }

    const formValues = this.zoneForm.value;

    // Create new ResourceZone
    const entry: Partial<ResourceZone> = {
      resource: this.data.resource,
      zone: formValues.zone,
      startDate: formValues.startDate
        ? moment(formValues.startDate).startOf("day").toDate()
        : null,
      endDate: formValues.endDate
        ? moment(formValues.endDate).startOf("day").toDate()
        : null,
      mappingPattern: formValues.mappingPattern
    };

    this.dialogRef.close({ action: "save", entry });
  }

  cancel(): void {
    this.dialogRef.close({ action: "cancel" });
  }
}
